module.exports = __webpack_public_path__ + "static/media/RollCall_iOS.cdedba85.png";